import { ExpertKnowledgeView } from "@/components/aicheck/ExpertKnowledgeView";
import type { ActiveTab } from "@/components/aicheck/hooks/useTraceabilityHistory";
import type { AICheckRunResult } from "@/types/aicheck";

interface ExpertKnowledgeTabProps {
  result: AICheckRunResult;
  activeTab: ActiveTab;
}

/**
 * 「エキスパート知識」タブ本体。tabpanel ラッパ + ExpertKnowledgeView。
 * 表示ゲート（expertAspectIds.length > 0）は親側に残す。
 */
export function ExpertKnowledgeTab({
  result,
  activeTab,
}: ExpertKnowledgeTabProps) {
  return (
    <div
      id="results-panel-expert-knowledge"
      role="tabpanel"
      aria-labelledby="results-tab-expert-knowledge"
      hidden={activeTab !== "expert-knowledge"}
    >
      <ExpertKnowledgeView result={result} />
    </div>
  );
}
